import { Component, OnInit } from '@angular/core';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { Feedback } from 'src/app/model/feedback.model';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  mainPageTitle = 'Feedback';
  questions: Feedback[];
  userinfo: any;
  enableButton: boolean = true;

  constructor(
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private dlaService: DlaService) { }

  ngOnInit(): void {
    this.loadScripts();

    this.userinfo = JSON.parse(localStorage.getItem('dla_student'));

    this.getQuestions();

  }

  getQuestions() {
    this.spinner.show();
    this.dlaService.getFeedbackQuestions(this.userinfo.user_id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {

          this.questions = data;
          //console.log(this.questions);
        } else {
          this.alertService.info(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  onSubmit() {
    console.log('Submitted');

    this.spinner.show();
    this.dlaService.submitFeedback(this.userinfo.user_id, this.questions).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          this.alertService.success(data.message);
          this.spinner.hide();
          console.log(data);
        } else {
          this.spinner.hide();
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }


  getResponse(value: number, index: number, question: Feedback) {

    // console.log(value);
    // console.log(index);
    // console.log(question);

    this.questions[index].rating = value;
    this.enableButton = false;

    // console.log(this.questions);

  }

  loadScripts() {
    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      // 'assets/js/morrisjs/raphael-min.js',
      // 'assets/js/morrisjs/morris.js',
      // 'assets/js/morrisjs/morris-active.js',
      'assets/js/sparkline/jquery.sparkline.min.js',
      'assets/js/sparkline/jquery.charts-sparkline.js',
      'assets/js/calendar/moment.min.js',
      'assets/js/calendar/fullcalendar.min.js',
      'assets/js/calendar/fullcalendar-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }


}
